import React from "react";
import PropTypes from "prop-types";
import NumberInput from "../../common/NumberInput";
import SelectInput from "../../common/SelectInput";
import TextInput from "../../common/TextInput";
import * as DomainConstants from "../../../constants/DomainConstants";

const BereikDoelgroepForm = (props) => {
	const {
		onChange,
		doelgroepenForSelectList,
		errors,
		disabled,
		isInTheFuture,
		indexes,
		bereikDoelgroep,
		validationMessageType
	} = props;

	const isAndereDoelgroep = bereikDoelgroep.doelgroep == DomainConstants.ANDERE_DOELGROEP_ID;
	let dropdownSize = isAndereDoelgroep ? 2 : 5;
	const noDecimals = true;

	const andereDoelgroepComponent = isAndereDoelgroep ? (<TextInput
		label="Andere doelgroep"
		name="andereDoelgroep"
		onChange={onChange}
		disabled={disabled}
		value={bereikDoelgroep.andereDoelgroep}
		size={3}
		validationMessage={errors ? errors.andereDoelgroep : ''}
		validationMessageType={validationMessageType}
		maxLength={200} />) : null;

	const aantalBezoekersPerJaarInputs = indexes.map((index) =>
		<NumberInput key={index}
			label={"Jaar " + (isInTheFuture ? index : ("-" + index))}
			name={"aantalBezoekersJaar" + index}
			onChange={onChange}
			disabled={disabled}
			value={bereikDoelgroep["aantalBezoekersJaar" + index] == 0 || bereikDoelgroep["aantalBezoekersJaar" + index] ? bereikDoelgroep["aantalBezoekersJaar" + index].toString() : ""}
			size={1}
			validationMessage={errors ? errors["aantalBezoekersJaar" + index] : ''}
			validationMessageType={validationMessageType}
			hideValidation
			noDecimals={noDecimals}
			fullWidthInput />);

	return (
		<div>
			<SelectInput
				label="Doelgroep"
				name="doelgroep"
				onChange={onChange}
				value={bereikDoelgroep.doelgroep}
				size={dropdownSize}
				disabled={disabled}
				items={doelgroepenForSelectList}
				validationMessage={errors ? errors.doelgroep : ''}
				validationMessageType={validationMessageType}
			/>
			{andereDoelgroepComponent}
			{aantalBezoekersPerJaarInputs}
		</div>
	);
};

// ----------------------------------------------------------------------------
BereikDoelgroepForm.propTypes = {
	onChange: PropTypes.func,
	isInTheFuture: PropTypes.bool.isRequired,
	doelgroepenForSelectList: PropTypes.array,
	errors: PropTypes.object,
	disabled: PropTypes.bool,
	indexes: PropTypes.arrayOf(PropTypes.number).isRequired,
	bereikDoelgroep: PropTypes.object,
	validationMessageType: PropTypes.string
};

export default BereikDoelgroepForm;